import React from 'react'
import { Link } from 'react-router-dom'
import { useEffect } from 'react'
import { useState } from 'react'
import axios from 'axios'
import Swal from 'sweetalert2'
import './TeacherPageLayout.css'

import { API_BASE_URL } from '../../config';

const baseUrl = API_BASE_URL;

const TeacherMyCourses = () => {
    useEffect(()=>{
        document.title='LMS | Uploaded Courses'
      })

      const [courseData, setCourseData]=useState([]);
      const teacherId=localStorage.getItem('teacherId');
      const [totalResult, settotalResult]=useState([0]);    

      useEffect(()=>{
        try{
            axios.get(baseUrl+'/teacher-course/'+teacherId)
            .then((res)=>{
                setCourseData(res.data)
            });
        }catch(error){
            console.log(error)
        }
      },[]);

      const handleDeleteClick = (course_id) =>{
        Swal.fire({
            title: 'Confirm',
            text: 'Are you sure you want to delete data?',
            icon: 'info',
            confirmButtonText: 'Continue',
            showCancelButton:true
          }).then((result)=>{
            if(result.isConfirmed){
                try{
                    axios.delete(baseUrl+'/teacher-course-detail/'+course_id)
                    .then((res)=>{
                        Swal.fire('success','Data has been deleted Successfully')
                        try{
                            axios.get(baseUrl+'/teacher-course/'+teacherId)
                            .then((res)=>{
                              settotalResult(res.data.length)
                              setCourseData(res.data)
                            });
                        }catch(error){
                            console.log(error);
                        }
                    })
            }catch(error){
                Swal.fire('error','Data has not been deleted !!');
            }
            }
            else{
                Swal.fire('error','Data has not been deleted !!');
            }
          })
    }
    useEffect(() => {
        window.scrollTo(0, 0)
      }, [])
  return (
    <>
        <div className='card'>
                    <h5 className='card-header'><i className="bi bi-journals"></i> My Courses</h5>
                    <div className='card-body table-responsive'>
                        <table className='table table-striped table-hover'>
                            <thead>
                                <tr>
                                    <th className='text-center'>Name</th>
                                    <th className='text-center'>Thumbnail</th>
                                    <th className='text-center'>Total Enrolled</th>
                                    {/* This column holds the row actions; the rating is rendered
                                        inside the Name cell, so the old "Ratings" label was wrong. */}
                                    <th className='text-center'>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {courseData.map((course,index) => 
                                    <tr>
                                    <td className='text-center'>
                                        <Link to={`/teacher/course-management/` +course.id}>{course.title}</Link>
                                        <hr />
                                        <i class="bi bi-star-fill text-warning"></i>&nbsp;
                                        {course.course_rating && 
                                            <span>Rating : {course.course_rating}/5</span>
                                        }
                                        {!course.course_rating && 
                                            <span>Rating : New</span>
                                        }
                                    </td>
                                    <td className='text-center'><img className='round' src={course.featured_img} width="80 " alt={course.title}/></td>
                                    <td className='text-center'><Link to={`/teacher/enrolled-students/`+course.id} title='View enrolled students and manage their course access'>{course.total_enrolled_students} <i className="bi bi-people-fill"></i><br /><small>Enrolled Students</small></Link></td>
                                    <td className='text-center'>
                                        <Link to={`/teacher/course-management/` +course.id} className='btn btn-secondary btn-sm ms-2  mb-2'><i class="bi bi-pencil-square"></i></Link>
                                        <Link to={`/teacher/study-material/` +course.id} className='btn btn-primary btn-sm ms-2 mb-2'>Study Material</Link>
                                        <Link to={`/teacher/course-management/` +course.id} className='btn btn-success btn-sm ms-2 mb-2'>Add Chapter</Link>
                                        {/* Explicit entry point to per-student access control. The
                                            enrolled-student count in the column above already linked
                                            here, but an unlabelled number was not discoverable.
                                            Show the count on the button too: opening this on a course
                                            with no enrolments lands on an empty list, which reads as
                                            the feature being broken. */}
                                        <Link to={`/teacher/enrolled-students/` +course.id}
                                              className='btn btn-warning btn-sm ms-2 mb-2'
                                              title={course.total_enrolled_students
                                                  ? 'Set each student to Auto, Unlocked or Locked'
                                                  : 'No students enrolled in this course yet'}>
                                            <i className="bi bi-sliders"></i> Manage Access ({course.total_enrolled_students || 0})
                                        </Link>
                                        <button onClick={()=>handleDeleteClick(course.id)} className='btn btn-danger btn-sm ms-2 mb-2'><i class="bi bi-trash"></i></button>
                                    </td>
                                </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div></>
  )
}

export default TeacherMyCourses
